import { useQueryClient } from "react-query";

import { AlertConfirmationModal } from "../alert-confirmation-modal";

import { useModalContext } from "../../../Contexts/ModalContext";

import { useCancelOneTimePayment, useCancelRecurringRentPayment } from "../../../CustomHooks/Mutations";

import { dispatchAPIErrorToast, dispatchSuccessToast, formatCurrency } from "../../../Utils/helpers";
import { APIQueryKeys, modalVariants } from "../../../Utils/constants";

export default function renderCancelRentPayment(modalContext, props) {
  const { updateModalComponent, pushModalStack, setModalVariant, setModalTitle, setModalClassName } = modalContext;

  updateModalComponent(() => <CancelRentPayment {...props} />);
  pushModalStack(() => renderCancelRentPayment(modalContext, props));
  setModalVariant(modalVariants.promptDialog);
  setModalTitle("");
  setModalClassName("");
}

const CancelRentPayment = ({ payee, total, type, transaction_id, id, isRecurringTransaction }) => {
  const queryClient = useQueryClient();

  const { popModalStack, onModalClose } = useModalContext();

  const onCancelSuccess = () => {
    dispatchSuccessToast(`${isRecurringTransaction ? "Recurring " : ""}Payment canceled successfully.`, {
      key: isRecurringTransaction ? "cancelRecurringRentPayment" : "cancelOneTimePayment",
    });
    queryClient.invalidateQueries(APIQueryKeys.recurringRentPayments);
    queryClient.invalidateQueries(APIQueryKeys.rentPayments);
    onModalClose();
  };

  const onCancelError = (err) =>
    dispatchAPIErrorToast(err?.response?.status === 422 ? { message: err?.response?.data?.error } : {});

  const { isLoading: isCancellingOneTimePayment, mutate: CancelOneTimePayment } = useCancelOneTimePayment({
    onSuccess: onCancelSuccess,
    onError: onCancelError,
  });

  const { isLoading: isCancellingRecurringRentPayment, mutate: CancelRecurringRentPayment } =
    useCancelRecurringRentPayment({
      onSuccess: onCancelSuccess,
      onError: onCancelError,
    });

  const handleCancelClick = () => {
    if (isRecurringTransaction) {
      CancelRecurringRentPayment(id);
    } else {
      CancelOneTimePayment({ payment_id: id });
    }
  };

  return (
    <AlertConfirmationModal
      variant="alert-error"
      title={`Cancel Payment to ${payee}?`}
      description={`You’re about to cancel your${
        isRecurringTransaction ? " recurring" : ""
      } payment of ${formatCurrency(total)} to ${payee}. ${
        isRecurringTransaction
          ? "This will stop all future payments from being sent to the payee."
          : type === "Recurring"
          ? "This will only stop this payment from being sent. Your recurring schedule will continue as usual."
          : "Since it hasn’t been processed yet, it will not be sent to the payee."
      }`}
      CTAButtonText="Confirm"
      onCTAButtonClick={handleCancelClick}
      isCTALoading={isCancellingOneTimePayment || isCancellingRecurringRentPayment}
      secondaryCTAButtonText="Cancel"
      onSecondaryCTAButtonClick={() => popModalStack(1)}
    />
  );
};
